import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteProjektStatusCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [DeleteProjektStatusCommandService],
  exports: []
})
export class DeleteProjektStatusCommandServiceModule { }
